export const SEGMENT_EVENTS = {
	FAILED_TO_FETCH_POSITION: 'Failed to fetch position',
	OPEN_WEBSITE: 'Open website',
};
